import {getSelfStoreList } from '../io/api.js'//应用mutation
export const setUser = ({commit},user) => {
  commit("userStatus",user)
}
// //获取用户头像
// export const setImage = ({commit},imageUrl) => {
//   commit("userImageGet",imageUrl)
// }
export const setToken = ({commit},userToken) => {
  commit("userToken",userToken)
}
export default {
	 //获取医案库列表
	getSelfStore_list({state,commit},params){
		getSelfStoreList().then(res=>{
			let data = res.data;
			if(data&&data.code==0){ 
				commit('setLibrarylistoptions',data.data)
			}else{
				commit('setToast',{type:'error',info:data.msg||'请求失败～'})
				// this.$message.error(data.msg||'请求失败～');
			}
			
		})
	},
}